<!--
Author:
Create Time: 2020-04-10 14:06:26
Description: 人事登记信息参照框
-->
<template>
  <el-dialog
    class="com-populregister-ref"
    top="10vh"
    :before-close="handleCancel"
    :close-on-click-modal="false"
    v-dialogDrag
    :modal="false"
    :width="width"
    v-bind="{...$props, ...$attrs}"
  >
    <el-form :inline="true" :model="condition" size="mini" style="margin-top: 20px;" label-suffix=":">
      <el-form-item label="姓名">
        <el-input v-model="condition.name" placeholder="模糊查询"></el-input>
      </el-form-item>
      <el-form-item label="联系电话">
        <el-input v-model="condition.phone" placeholder="模糊查询"></el-input>
      </el-form-item>

      <el-form-item label="证件号码">
        <el-input v-model="condition.cardEQ" placeholder="精确查询"></el-input>
      </el-form-item>

      <el-form-item>
        <el-button @click="search">搜索</el-button>
      </el-form-item>
    </el-form>
    <div style="padding: 0px 10px;height:360px; padding-bottom: 2em;">
      <el-table
        :data="pageData.list"
        border
        class="table"
        ref="multipleTable"
        align="center"
        height="100%"
        @row-click="handleRowClick"
        @selection-change="handleSelectionChange"
        :key="multiple ? 'multiple' : 'radio'"
      >
        <el-table-column width="50" fixed="left" align="center" show-overflow-tooltip v-if="!multiple">
          <template slot-scope="scope">
            <el-radio :label="scope.row.id" v-model="selectedRowId">&nbsp;</el-radio>
          </template>
        </el-table-column>
        <el-table-column width="50" fixed="left" align="center" show-overflow-tooltip v-if="multiple" type="selection"></el-table-column>

        <el-table-column prop="code" align="center" label="编码" min-width="180" show-overflow-tooltip sortable></el-table-column>
        <el-table-column prop="name" align="center" label="姓名" min-width="180" show-overflow-tooltip sortable></el-table-column>
        <el-table-column prop="sex" align="center" label="性别" min-width="180" show-overflow-tooltip sortable width="80"></el-table-column>
        <el-table-column prop="phone" align="center" label="联系电话" min-width="180" show-overflow-tooltip sortable></el-table-column>
        <el-table-column prop="orgName" align="center" label="组织" min-width="180" show-overflow-tooltip sortable></el-table-column>
        <el-table-column prop="deptName" align="center" label="部门" min-width="180" show-overflow-tooltip sortable></el-table-column>
        <el-table-column prop="postName" align="center" label="部门" min-width="180" show-overflow-tooltip sortable></el-table-column>
      </el-table>
      <div data-ignore-class="pagination">
        <pagination
          data-ignore-style="float:right"
          style="text-align: right;"
          :page-list="pageData"
          @pagesearch="handlePage"
        ></pagination>
      </div>
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button @click="handleCancel">取 消</el-button>
      <el-button type="primary" @click="handleConfirm">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
// import accounting from "accounting"; // 数字格式

function newSearchCondition() {
  return {
    // 查询列表数据的条件
    loginUser: window.sessionStorage.getItem("userId"),

    name: undefined,
    phone: undefined,
  };
}

export default {
  name: "proRewardPunishRegisterRef",
  data() {
    return {
      condition: newSearchCondition(),
      pageData: {
        list: [],
        pageNumber: 1,
        pageSize: 10,
        totalCount: 0,
        totalPage: 0
      },
      selectedRowId: "", //单选列表选中的id

      selection: [],

      sexOptions4Form: [],
      categoryOptions4Form: [],
      identityTypeOptions4Form: [],
      maritalStatusOptions4Form: [],
      politicsStatusOptions4Form: [],
      householderRelationOptions4Form: [],
      isEnterpriseOptions4Form: [],
      isDieOptions4Form: [],
      degreeEducationOptions4Form: [],
      religionOptions4Form: [],
      emergencyContactRelationOptions4Form: [],
      statusOptions4Form: [],

      yesOrNoOptions: [],
    };
  },
  watch: {
    visible(val) {
      if (val) {
        this.condition = newSearchCondition();
        this.search();

        this.selectedRowId = null;
        this.selection = [];
      }
    }
  },
  props: {
    custAddCheck: {//客户档案新增属性：true-排除数据空校验
      type: Boolean,  
      default: () => false
    },
    visible: {
      type: Boolean,
      default: () => false
    },
    multiple: {
      type: Boolean,
      default: () => false
    },
    width: {
      type: String,
      default: () => "80%"
    },
  },
  methods: {
    handleCancel() {
      this.$emit("cancel");
    },
    handleConfirm() {
      if (this.multiple ? (this.selection.length === 0) : !this.selectedRowId && !this.custAddCheck) {
        this.$message.warning('请选择数据');
        return;
      }
      this.$emit(
        "confirm",
        this.multiple ? this.selection : this.pageData.list.find(item => item.id === this.selectedRowId)
      ); 
    },
    search() {
      this.pageData.pageNumber= 1;
      return this.getData(this.pageData.pageNumber, this.pageData.pageSize);
    },
    getData(number, size) {
        return this.$http
          .post(this.api.ProPersonQueryByCondition, {
            condition: this.condition,
            number: number,
            size: size
          })
          .then(res => {
            if (res.data && res.data.code === "200") {
              this.pageData.list = res.data.body.records;
              this.pageData.totalCount = res.data.body.total;
              this.pageData.totalPage = res.data.body.pages;
            }
          });
    },
    handlePage(number, size) {
      this.pageData.pageNumber = number;
      this.pageData.pageSize = size;
      this.getData(this.pageData.pageNumber, this.pageData.pageSize);
    },
    //行选择
    handleRowClick(row) {
      this.selectedRowId = row.id;
    },
    handleSelectionChange(selection) {
      this.selection = selection;
    },
  },
  mounted() {
    this.yesOrNoOptions = [ { label: '是', value: '是' }, { label: '否', value: '否' } ];
    let yesOrNoOptions = this.yesOrNoOptions;
    let sysDic = JSON.parse(localStorage.getItem('sysDic')||'{}');
    
    /* ---- 人口基本信息 ---- */
    this.sexOptions4Form = [ { label: '男', value: '男' }, { label: '女', value: '女' } ];
    this.categoryOptions4Form = sysDic.hkxz||[];
    this.identityTypeOptions4Form = sysDic.sflb||[];
    this.maritalStatusOptions4Form = sysDic.hyzt||[];
    this.politicsStatusOptions4Form = sysDic.zzmm||[];
    this.isCtyCensusOptions4Form = yesOrNoOptions;
    this.householderRelationOptions4Form = sysDic.yzgx||[];
    this.isEnterpriseOptions4Form = yesOrNoOptions;
    this.isDieOptions4Form = yesOrNoOptions;
    this.degreeEducationOptions4Form = sysDic.jycd||[];
    this.religionOptions4Form = sysDic.zjxy||[];
    this.emergencyContactRelationOptions4Form = sysDic.qsgx||[];
    this.statusOptions4Form = sysDic.enabled||[];
  }
};
</script>

<style scoped lang="less">
// .com-populregister-ref {}
</style>



// WEBPACK FOOTER //
// src/components/proRewardPunishRegister/proRewardPunishRegisterRef.vue